import React, { useState, useEffect } from 'react';
import { useOutletContext, useSearchParams } from 'react-router-dom';
import { supabase } from '../../utils/supabase';
import { Card } from '../../components/common/Card';
import { Heading, Text } from '../../components/common/Typography';
import { BackButton } from '../../components/common';
import UnifiedHeadToHead from '../../components/player/UnifiedHeadToHead';

/**
 * ProfileHeadToHead - Matchups comparison page for all clubs
 * Shows matchup records across all clubs the user is a member of
 */
const ProfileHeadToHead = () => {
  const { currentUser } = useOutletContext();
  const [searchParams] = useSearchParams();
  const initialOpponentId = searchParams.get('opponentId') || null;
  const initialClubId = searchParams.get('clubId') || null;
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (currentUser?.id) {
      setLoading(false);
    }
  }, [currentUser?.id]);

  if (loading || !currentUser?.id) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Back Button */}
      <BackButton onClick={() => window.history.back()}>
        Back
      </BackButton>

      {/* Header */}
      <div>
        <Heading level={2} className="mb-2">
          Matchups
        </Heading>
        <Text className="text-slate-600">
          Compare your performance against other players across all your clubs. Select a teammate to see partnership stats, or select opponents to see your matchup history.
        </Text>
      </div>

      {/* Matchups — null selectedClub means all clubs */}
      <UnifiedHeadToHead
        currentPlayerId={currentUser.id}
        selectedClub={null}
        selectedSeason={null}
        initialOpponentId={initialOpponentId}
        initialClubId={initialClubId}
      />
    </div>
  );
};

export default ProfileHeadToHead;

